var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLemonSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4838 8.481C13.0585 4.84312 12.6189 0.474482 9.38526 0.777639C8.47577 1.28288 6.01504 2.38251 5.05211 3.6664C4.14264 4.87903 2.16355 7.14365 1.55724 9.26575C0.950924 11.3878 3.01924 13.8661 3.92871 15.3819C4.83818 16.8977 7.92354 21.0889 9.74248 22.3015C11.5614 23.5141 20.6193 24.6902 22.7057 20.678C24.4582 17.3078 17.909 12.1189 15.4838 8.481Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5932 11.9049C14.1081 11.4199 9.13633 14.5325 7.31738 17.0588C8.53001 18.8777 11.8647 20.6965 13.0774 20.9997C14.29 21.3029 15.1995 12.5112 14.5932 11.9049Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8969 11.9054C14.5164 11.3347 18.9066 16.0004 20.6566 18.5749C20.3045 20.3849 12.1531 21.2335 13.3811 21.0003C13.6843 20.9427 15.5032 12.8149 14.8969 11.9054Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9867 11.2987C14.4703 11.7852 9.74287 13.7239 7.31753 17.0587C5.49834 15.5429 4.31133 11.7074 4.01187 10.4938C3.71242 9.2803 13.3823 10.6905 13.9867 11.2987Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6834 10.9955C14.3166 11.2594 10.565 7.15887 8.83292 3.41684C7.26298 4.75611 3.98268 6.75148 3.98268 10.0862C3.98268 10.4209 10.0457 9.47974 13.6834 10.9955Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5101 10.4882C15.5101 10.0031 13.6911 9.71503 13.6911 11.0945C13.5692 12.3072 14.9643 12.3072 15.2069 12.3072H15.2069C15.8131 12.3072 15.5101 11.0945 15.5101 10.4882Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonSlice);
export default __webpack_public_path__ + "static/media/lemon-slice.7e894d91b45db629baed81b5fa260c6c.svg";
export { ForwardRef as ReactComponent };